import React from 'react';
import { Col } from 'antd';
import { useHistory, useParams } from 'react-router-dom';
import useScreenSize from 'use-screen-size';
import 'src/pages/userComponents/userStyle.scss';
import 'antd/dist/antd.css';
import TextComponent from '@sharedComponent/typography/TextComponent';
import EdenredButton from './../../../button/index';
import 'src/pages/userComponents/menus/salesforce-landing/salesforcelanding.scss';
import WebsiteRightPanel from 'src/assets/img/SalesForce_Icon/WebsiteRightPanel.svg';
import Edenredlogo from 'src/assets/img/SalesForce_Icon/Edenredlogo.svg';

const SalesForcePresentational = ({ getOpportunityInfoStart, isOpportunityLoading, opportunityData }) => {
	const history = useHistory();
	const size = useScreenSize();
	const { optId } = useParams();
	return (
		<Col>
			<div
				style={{
					width: '100vw',
					height: '100vh',
					display: 'flex',
					flexDirection: 'row',
				}}
				className="salesForceLandingPage">
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						width: size.width < 786 ? '100%' : '40%',
						height: '100%',
						padding: '0% 7% 0px 10%',
						justifyContent: 'center',
					}}>
					<div style={{ position: 'absolute', top: size.width > 786 ? '10px' : '40px' }}>
						{size.width < 786 ? (
							<img style={{ height: '100px', width: '100px' }} src={Edenredlogo}></img>
						) : (
							<img style={{ height: '50px', width: '70px' }} src={Edenredlogo}></img>
						)}
					</div>

					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'center',
							height: '100vh',
						}}>
						<TextComponent className="welcometext" style={{ fontFamily: 'Montserrat-Bold' }}>
							Welcome,
						</TextComponent>
						<TextComponent className="subwelcomeText" style={{ fontFamily: 'Montserrat-Bold' }}>
							{opportunityData && opportunityData.WelcomePage &&
								opportunityData.WelcomePage.opportunityData &&
								opportunityData.WelcomePage.opportunityData.opportunity &&
								opportunityData.WelcomePage.opportunityData.opportunity.companyViewModel ?
								opportunityData.WelcomePage.opportunityData.opportunity.companyViewModel.mainTradeLicenseName :
								''}
						</TextComponent>

						<div style={{ marginTop: '20px' }}>
							<TextComponent className="company_name_text">
								<p>We're eager to have you onboard with Edenred UAE, the largest payroll card provider in the region.</p>
							</TextComponent>
						</div>

						<div style={{ marginTop: '15px' }}>
							<TextComponent className="company_name_text">
								<p>Ensure that the information you provide is accurate for us to serve you better.</p>
							</TextComponent>
						</div>
						<div style={{ marginTop: '5px' }}>
							<TextComponent className="company_name_subtext">Let's get you setup quickly!</TextComponent>
						</div>
						<div style={{ marginTop: '10px' }}>
							<EdenredButton
								style={{ fontWeight: '700' }}
								disabled={false}
								type={'primary'}
								loading={isOpportunityLoading}
								onClick={() => {
									getOpportunityInfoStart(history, optId, true);
								}}>
								{'Sign Up'}
							</EdenredButton>
						</div>
					</div>
				</div>
				{size.width < 768 ? null : (
					<div
						style={{
							zIndex: '-1',
							height: '100%',
							width: '60%',
							display: 'flex',
							justifyContent: 'flex-end',
						}}>
						<img style={{ objectFit: 'cover' }} width="100%" height="100%" src={WebsiteRightPanel}></img>
					</div>
				)}
			</div>
		</Col>
	);
};
export default SalesForcePresentational;
